import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saGtpDataVolumeChartConfig } from '../chartConfigs';

interface GtpDataVolumeSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const GtpDataVolumeSaEcharts: React.FC<GtpDataVolumeSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saGtpDataVolumeChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default GtpDataVolumeSaEcharts;
